// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__j01Xi","name":"Header_name__1MHkG","birthday":"Header_birthday__1JER3","skeleton":"Header_skeleton__3WeqR"};